import ProductChip from './ProductChip';

const WandIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M15 4V2" />
    <path d="M15 16v-2" />
    <path d="M8 9h2" />
    <path d="M20 9h2" />
    <path d="M17.8 11.8L19 13" />
    <path d="M15 9h0" />
    <path d="M17.8 6.2L19 5" />
    <path d="M11 6.2L9.7 5" />
    <path d="M11 11.8L9.7 13" />
    <path d="M3 21l9-9" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3,6 5,6 21,6" />
    <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
  </svg>
);

function StagingArea({ products, onRemove, onClear, onAutoFill, isAutoFilling }) {
  return (
    <div className="staging-area">
      <div className="staging-header">
        <div className="staging-title">
          <span>Staging</span>
          {products.length > 0 && (
            <span className="staging-count">{products.length}</span>
          )}
        </div>
        {products.length > 0 && (
          <button
            className="staging-clear-btn"
            onClick={onClear}
            title="Clear all"
          >
            <TrashIcon />
          </button>
        )}
      </div>

      {products.length === 0 ? (
        <div className="staging-empty">
          <p>Search or upload to add products here</p>
        </div>
      ) : (
        <div className="staging-chips">
          {products.map((product, index) => (
            <ProductChip
              key={product.retailer_sku_id || product.id || index}
              product={product}
              onRemove={() => onRemove(index)}
            />
          ))}
        </div>
      )}

      <button
        className="auto-fill-btn"
        onClick={onAutoFill}
        disabled={products.length === 0 || isAutoFilling}
        title="Auto-fill flyer with staged products using AI insights"
      >
        <WandIcon />
        {isAutoFilling ? 'Placing...' : 'Auto-Fill Flyer'}
      </button>
    </div>
  );
}

export default StagingArea;
